module.exports = __webpack_public_path__ + "img/maintenance-guide.6e7630e0.png";